export default "__VITE_ASSET__5ca8bf22__"